<template>
  <div class="flex min-h-screen items-center justify-center">
    <div class="text-center">
      <h1 class="text-4xl font-bold mb-4">
        {{ error?.statusCode === 404 ? 'Sayfa Bulunamadı' : 'Bir Hata Oluştu' }}
      </h1>
      <p class="text-gray-600 mb-6">
        {{ error?.message || 'Beklenmeyen bir hata oluştu' }}
      </p>
      <UButton icon="i-heroicons-arrow-left" @click="handleError">
        Ana Sayfaya Dönn
      </UButton>
    </div>
  </div>
</template>

<script setup>
const props = defineProps({
  error: Object
})

// Basit hata loglaması
onMounted(() => {
  if (props.error) {
    console.error(props.error)
  }
})

const handleError = () => {
  clearError()
  navigateTo('/')
}
</script>
